var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgMobility = function SvgMobility(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Mobility_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 75 75",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Mobility_svg__st1{fill:#262a30}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.8 50.1l-3.7 2-7.3-14h-13v-4.2h9.8v-2.7h-9.8v-8.1l.3-.1c1.8-.3 3.2-1.9 3.2-3.8 0-2.1-1.7-3.9-3.8-3.9s-3.8 1.7-3.8 3.9c0 1.2.5 2.2 1.4 3l.1.1v18.6h14.1L44 55.8l6.1-3.3-1.3-2.4zM20.1 35.4v-3.3c-4.7 2.5-7.7 7.4-7.7 12.9 0 8.1 6.5 14.6 14.5 14.6 5.7 0 10.8-3.4 13.2-8.5l-1.7-3.2c-1.3 5.3-6 9.1-11.5 9.1-6.5 0-11.8-5.3-11.8-11.9 0-3.9 1.8-7.5 5-9.7z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#262a30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Mobility_svg__st1",
    d: "M56.1 59.1c-2.5 0-4.6-2.1-4.6-4.6s2.1-4.6 4.6-4.6 4.6 2.1 4.6 4.6-2.1 4.6-4.6 4.6zm0-6.9c-1.3 0-2.3 1-2.3 2.3 0 1.3 1 2.3 2.3 2.3s2.3-1 2.3-2.3c-.1-1.3-1.1-2.3-2.3-2.3zM63.9 31.7l-2.5-1-3.5 8.6h-8.4L45 31.1h-9.5v2.7h7.8l9 16.2 2.4-1.4-3.6-6.5h8.7z"
  })));
};
export default SvgMobility;